export default [{
        path: '/transaction/:code/detail',
        name: 'Transaction.Detail',
        component: () =>
            import (
                '@/views/Transaction/Detail.vue'
            ),
        meta: {
            title: 'Detail Transaction',
            icon: 'fas fa-shopping-cart fa-2x'
        },
    },
    {
        path: '/transaction/paylater',
        name: 'Transaction.Paylater',
        component: () =>
            import (
                '@/views/Transaction/PayLaterList.vue'
            ),
        meta: {
            title: 'Paylater',
            icon: 'fas fa-shopping-cart fa-2x'
        },
    },
    {
        path: '/transaction/paylater/:id',
        name: 'Transaction.Paylater.Detail',
        component: () =>
            import (
                '@/views/Transaction/PayLaterDetail.vue'
            ),
        meta: {
            title: 'Detail Paylater',
            icon: 'fas fa-shopping-cart fa-2x'
        },
    },
]